export default {"src":"/_next/static/media/profile-clip-2.ab0b6db6.svg","height":122,"width":122,"blurWidth":0,"blurHeight":0};